import reducer, { actions } from './slice';
import * as asyncActions from './asyncActions';
import * as selectors from './selectors';

export const organizationAffiliationStore = {
  actions,
  asyncActions,
  selectors,
};

export default reducer;
